<template>
  <div>
    <br />
    <el-form
      ref="dataForm"
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="
        pageIndex = 1
        getDataList()
      "
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="产品系列" prop="type">
            <el-select v-model="dataForm.type" placeholder="请选择产品系列">
              <el-option
                v-for="item in typeOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运行端" prop="terminal">
            <el-select v-model="dataForm.terminal" placeholder="请选择运行端">
              <el-option
                v-for="item in terminals"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="dataForm.name" placeholder="产品名称"></el-input>
          </el-form-item>
          <el-form-item label="客户名称" prop="customer">
            <el-input
              v-model="dataForm.customer"
              placeholder="客户名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="维护用户姓名"
            prop="maintainer"
            v-if="perm === 'admin'"
          >
            <el-input
              v-model="dataForm.maintainer"
              placeholder="维护用户姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                pageIndex = 1
                getDataList(true)
              "
              >查询</el-button
            >
            <el-button @click="refreshForm()">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="mb-md">
      <el-col :span="24">
        <el-button
          v-if="perm !== 'admin'"
          type="primary"
          @click="addProduction()"
        >
          <i class="el-icon-plus"></i>
          新增产品信息
        </el-button>
        <el-button type="primary" @click="download()">
          <i class="el-icon-download"></i>
          导出访问下载统计
        </el-button>
      </el-col>
    </el-row>
    <el-table :data="dataList" v-loading="tabLoding" border style="width: 100%">
      <el-table-column
        prop="productSeries"
        header-align="center"
        align="center"
        label="产品系列"
      >
      </el-table-column>
      <el-table-column
        prop="productNumber"
        header-align="center"
        align="center"
        label="产品编号"
      >
      </el-table-column>
      <el-table-column
        prop="productName"
        header-align="center"
        align="center"
        label="产品名称"
      >
      </el-table-column>
      <el-table-column
        prop="execEnd"
        header-align="center"
        align="center"
        label="运行端"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        header-align="center"
        align="center"
        label="客户名称"
      >
      </el-table-column>
      <el-table-column
        prop="note"
        header-align="center"
        align="center"
        width="200px"
        show-overflow-tooltip
        label="备注"
      >
        <template slot-scope="scope">{{ scope.row.note || '-' }}</template>
      </el-table-column>
      <el-table-column
        v-if="perm === 'admin'"
        prop="'maintainerUserName"
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="维护用户"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="点击修改维护用户"
            placement="top"
          >
            <el-button type="text" size="small" @click="maintain(scope.row)">{{
              scope.row.maintainerUserName || '-'
            }}</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="250"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="perm !== 'admin'"
            type="text"
            size="small"
            @click="editProduction(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="perm !== 'admin'"
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            >删除</el-button
          >
          <el-button
            v-if="scope.row.existsOfficialVersion && perm !== 'admin'"
            type="text"
            size="small"
            @click="dwCode(scope.row)"
            >产品二维码</el-button
          >

          <el-button type="text" size="small" @click="detail(scope.row)"
            >版本详情</el-button
          >
          <el-button
            v-if="perm === 'admin'"
            type="text"
            size="small"
            @click="productDescribe(scope.row)"
            >产品详情</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="perm !== 'admin'"
            @click="toEquipment(scope.row)"
            >设备白名单</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="perm === 'admin'"
            @click="equipList(scope.row)"
            >设备白名单</el-button
          >
          <el-button
            size="small"
            type="text"
            @click="addVersionModal(scope.row)"
            v-if="perm !== 'admin'"
          >
            <i class="el-icon-plus"></i>
            新版本
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="totalPage > 0">
      <el-pagination
        class="mt-sm"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <add-production
      v-if="addVisible"
      ref="addModal"
      @refreshDataList="getDataList"
      :status="status"
    ></add-production>
    <maintain-user
      v-if="mainVisible"
      ref="maintainModal"
      @refreshMaintain="refreshMaintain($event)"
    ></maintain-user>
    <!-- <equipment-list
      v-if="equipmentVisible"
      ref="equipmentInfo"
      @refreshDataList="getDataList"
    ></equipment-list> -->
    <upload-modal
      v-if="uploadVisible"
      ref="uploadModal"
      :productId="currentId"
      :productNumber="productNumber"
      :productName="productName"
      :productType="productSeries"
      @refreshDataList="getDataList"
      :pstatus="status1"
    ></upload-modal>
    <see-equipment
      v-if="equipmentVisible"
      ref="equipmentInfo"
      @refreshDataList="getDataList"
    ></see-equipment>
    <el-dialog
      title="产品二维码"
      :visible.sync="codeVisible"
      width="400px"
      :before-close="codeClose"
    >
      <div class="text-center">
        <p class="qrcodeurl">{{ qrcodeurl }}</p>
        <canvas id="QRCode_box"></canvas>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SeeEquipment from '../equipmentlist/SeeEquipment.vue'
import AddProduction from './components/AddProduction.vue'
import MaintainUser from './components/MaintainUser.vue'
import httpMethods from '@/api/product/http.js'
import UploadModal from '../version/components/UploadModal.vue'
import QRCode from 'qrcode'
import config from '@/config'
import Vue from 'vue'
import encryption from '../../utils/encryption.js'

export default {
  data() {
    return {
      waitTestVersionInfo: null, // 待测试版本
      publickey: '', // sm2获取的公钥
      time: '', // sm2获取的时间戳
      productId: '',
      versionId: '',
      dataForm: {
        type: '全部',
        terminal: '全部',
        name: '',
        customer: '',
        maintainer: ''
      },
      typeOptions: [],
      terminals: [],
      tabLoding: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      addVisible: false,
      mainVisible: false,
      equipmentVisible: false,
      uploadVisible: false,
      currentId: '',
      productNumber: '',
      productType: '',
      productName: '',
      productSeries: '',
      status: ' ',
      status1: '',
      codeVisible: false,
      qrcodeurl: ''
    }
  },
  components: {
    AddProduction,
    MaintainUser,
    UploadModal,
    SeeEquipment
  },
  computed: {
    username() {
      return this.$store.state.username
    },
    perm() {
      return this.$store.state.perm
    }
  },
  mounted() {
    this.getTerminals()
    this.getTypes()
    this.getDataList()
    // this.getKeys()
  },
  methods: {
    toEquipment(info) {
      this.$router.push(
        '/equipment?proId=' + info.id + '&proName=' + info.productName
      )
    },
    formatDate(row, column) {
      // 获取单元格数据
      const data = row[column.property]
      if (data == null) {
        return null
      }
      const dt = new Date(data)
      const time =
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      return time
    },
    // 跳转到白名单模态页
    equipList(info) {
      this.equipmentVisible = true
      this.$nextTick(() => {
        this.$refs.equipmentInfo.init(info)
      })
    },
    // 获取产品系列
    getTypes() {
      httpMethods
        .getTypes()
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            this.typeOptions = ['全部']
            data.list.forEach((item) => {
              this.typeOptions.push(item)
            })
          } else {
            this.typeOptions = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch((err) => {
          this.typeOptions = []
          console.log('err => ', err)
        })
    },
    getTerminals() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getExecEnd'),
        method: 'get'
      })
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            this.terminals = ['全部']
            data.list.forEach((item) => {
              this.terminals.push(item)
            })
          } else {
            this.terminals = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {
          this.terminals = []
        })
    },
    getDataList() {
      this.tabLoding = true
      this.$http({
        url: this.$http.adornUrl('/api/app/getProductInfo'),
        method: 'get',

        params: this.$http.adornParams({
          pageNum: this.pageIndex,
          pageSize: this.pageSize,
          execEnd:
            this.dataForm.terminal === '全部' ? '' : this.dataForm.terminal, // 运行端
          productName: this.dataForm.name.trim(),
          productSeries:
            this.dataForm.type === '全部' ? '' : this.dataForm.type,
          userName: this.dataForm.customer.trim(),
          // loginName: this.dataForm.maintainer.trim()
          maintainer: this.dataForm.maintainer.trim()
        })
      })
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            if (data.list.length === 0 && data.total > 0) {
              this.pageIndex = this.pageIndex - 1
              this.getDataList()
            } else {
              this.dataList = data.list
              this.totalPage = data.total
            }
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.tabLoding = false
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.tabLoding = false
        })
    },
    refreshForm() {
      this.$refs.dataForm.resetFields()
      this.pageIndex = 1
      this.getDataList()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 新增产品信息
    addProduction() {
      this.status = ''
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addModal.init('')
      })
    },
    // 编辑产品信息
    editProduction(info) {
      this.currentId = info.id
      this.addVisible = true
      this.status = ''
      this.$nextTick(() => {
        this.$refs.addModal.init(info)
      })
    },
    // 产品详情
    productDescribe(info) {
      this.currentId = info.id
      this.status = 'desc'
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addModal.init(info)
      })
    },
    // 上传安装包
    addVersionModal(info) {
      this.$http
        .all([this.exitsWaitTesting(info)])
        .then(
          this.$http.spread((res1) => {
            if (res1.resp_code === 0) {
              this.waitTestVersionInfo = res1.data
            }
          })
        )
        .then(() => {
          if (this.waitTestVersionInfo !== null) {
            // 有待测试的版本
            this.addVersionConfirm(info)
          } else {
            this.openAddVersionModal(info)
          }
        })
    },
    // 弹出新版本模态页
    openAddVersionModal(info) {
      this.status1 = 'add'
      this.uploadVisible = true
      this.currentId = info.id
      this.productNumber = info.productNumber
      this.productName = info.productName
      this.productSeries = info.productSeries
      this.$nextTick(() => {
        this.$refs.uploadModal.init(info)
      })
    },
    addVersionConfirm(info) {
      this.$confirm(
        '该产品下存在未开启测试的版本，再次创建新版本会导致其被删除无法找回，继续操作吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.openAddVersionModal(info)
        })
        .catch(() => {})
    },
    // 新增版本的时候，判断是否有未开启测试的版本，如果有，需要先把原来的待测试版本删掉
    exitsWaitTesting(info) {
      return this.$http({
        url: this.$http.adornUrl('/api/app/getProductVersionWaitTest'),
        method: 'get',
        params: this.$http.adornParams({
          productId: info.id
        })
      })
    },
    updateRemark(e) {
      this.dataList.forEach((item) => {
        if (item.id === this.currentId) {
          item.note = e
        }
      })
    },
    // 修改维护用户
    maintain(info) {
      this.currentId = info.id
      this.mainVisible = true
      this.$nextTick(() => {
        this.$refs.maintainModal.init(info)
      })
    },
    // 更新维护用户
    refreshMaintain(e) {
      this.dataList.forEach((item) => {
        if (item.id === this.currentId) {
          item.maintainerUserName = e.name
          item.maintainerId = e.id
        }
      })
    },
    // 删除
    deleteHandle(id) {
      this.$confirm('确认进行删除操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl('/api/app/deleteProductInfo'),
            method: 'delete',

            params: this.$http.adornParams({
              id: id
            })
          }).then((res) => {
            if (res.resp_code === 0) {
              this.getDataList()
              this.$message({
                message: '删除成功',
                type: 'success',
                duration: 1500
              })
            } else {
              this.$message.error(res.resp_msg || '操作失败')
            }
          })
        })
        .catch(() => {})
    },
    // 二维码弹框
    dwCode(info) {
      this.productId = info.id
      this.codeVisible = true
      this.$nextTick(() => {
        // this.getKeys()
        this.getQRCode()
        this.getLastVersion()
      })
    },
    getQRCode() {
      const opts = {
        errorCorrectionLevel: 'H', // 容错级别
        type: 'image/png', // 生成的二维码类型
        quality: 0.3, // 二维码质量
        margin: 12, // 二维码留白边距
        width: 200, // 宽
        height: 180, // 高
        color: {
          dark: '#333333', // 前景色
          light: '#fff' // 背景色
        }
      }
      // 二维码后面的参数，产品id+版本id
      // const sm2 = require('sm-crypto').sm2
      // const cipherMode = 1 // 1 - C1C3C2，0 - C1C2C3，默认为1
      // const productId = sm2.doEncrypt(
      //   this.productId,
      //   this.publickey,
      //   cipherMode
      // ) // sm2加密
      // const versionId = sm2.doEncrypt(
      //   this.versionId,
      //   this.publickey,
      //   cipherMode
      // ) // sm2加密
      const productId = encryption.Encrypt(this.productId)
      // const versionId = encryption.Encrypt(this.versionId)

      this.qrcodeurl =
        location.origin +
        '/#/productload?productId=' +
        encodeURIComponent(productId) // 生成的二维码为URL地址js

      const msg = document.getElementById('QRCode_box')
      QRCode.toCanvas(msg, this.qrcodeurl, opts)
    },
    // 获取产品的最新版本信息
    getLastVersion() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getLatestProductVersion'),
        method: 'get',
        params: this.$http.adornParams({
          productId: this.productId
        })
      }).then((res) => {
        const data = res.data
        if (data && res.resp_code === 0) {
          this.versionId = res.data.id
        } else {
          this.versionId = ''
          this.$message.error(res.resp_msg)
        }
      })
    },
    // 获取sm2的公钥和时间戳
    // getKeys() {
    //   httpMethods
    //     .keys()
    //     .then((res) => {
    //       this.loading = false
    //       const data = res.data
    //       if (data && res.resp_code === 0) {
    //         this.publickey = '04' + res.data.PublicKey
    //         this.time = res.data.time
    //       } else {
    //         this.publickey = ''
    //         this.time = ''
    //         this.$message.error(res.resp_msg)
    //       }
    //     })
    //     .catch(() => {})
    // },
    codeClose() {
      this.codeVisible = false
    },
    download() {
      window.location.href =
        config.baseURL +
        '/api/app/download/getStatisticExcel?token=' +
        Vue.cookie.get('token')
    },
    detail(info) {
      this.$router.push(
        '/version?id=' + info.id + '&proName=' + info.productName
      )
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-page-header__left {
  display: none;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  color: aqua !important;
}
.text-center {
  text-align: center;
  .qrcodeurl {
    text-align: left;
  }
}
</style>
